import api from './api';

const ingresoService = {
  listar: async (filtros = {}) => {
    const { data } = await api.get('/ingresos', { params: filtros });
    return data.data;
  },

  crear: async (ingreso) => {
    const { data } = await api.post('/ingresos', ingreso);
    return data.data;
  },

  actualizar: async (id, ingreso) => {
    const { data } = await api.put(`/ingresos/${id}`, ingreso);
    return data.data;
  },

  eliminar: async (id) => {
    await api.delete(`/ingresos/${id}`);
  },
};

export default ingresoService;